import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 16px;
  margin-bottom: 14px;
`;
